module.exports = function() {
  return new Worker(__webpack_public_path__ + "210a4c7894863498ddfa.worker.js");
};